exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".separator[data-v-22bedcdc]{margin:auto;width:80%;border-bottom:1px solid #d3d3d3;border-color:#ff792c}.separator.ready[data-v-22bedcdc]{border-color:#70be00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22bedcdc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Separator.vue
// module id = 122
// module chunks = 0